<template lang="html">
<div>

  <div
    id="LadderStaker"
    class="anchor"
  ></div>

  <v-flex class="mt-5">

      <v-flex class="d-flex flex-column justify-center pt-10 mb-10">

        <h1 class="text-center">Ladder Staker</h1>

        <p class="mx-5 mt-10 text-center" max-width="800">
          Use this tool to easily create Ladder Stakes. What are Ladder Stakes? Multiple stakes, ending with a given time interval, like the first stake expires after 3 months, the second stake ends after 6 months, the third one after 9 months, etc... This way you have a regular income without having to emergency unstake or scrapping your interest.
        </p>
        <p class="mx-5 mt-0 text-center font-weight-bold" max-width="800">
          Using Ladder Staker saves you gas costs compared to doing all transactions individually because only one transaction is needed!
        </p>
        <p class="mx-5 mt-0 text-center" max-width="800">
          More Info how to use Ladder Staker here:
        </p>
        <v-flex class="d-flex flex-wrap justify-center">
          <v-btn
            color="#3C44B1"
            class="my-3 mx-2 text-none"
            href="https://wiseinfo.medium.com/how-to-easily-create-wise-ladder-stakes-with-wiseinfo-io-d55a0654644"
            target="_blank"
            height="70"
            contain
            x-large
          >
          <div class="title font-weight-bold text-center">
            How to easily create WISE Ladder Stakes <br />
            with wiseinfo.io (Medium Article)
          </div>
          </v-btn>
        </v-flex>
        <v-flex class="d-flex flex-wrap justify-center">
          <v-btn
            color="#29ABB5"
            class="my-3 mx-2 text-none"
            href="https://testnet.wiseinfo.io/#LadderStaker"
            contain
            small
          >
            <span class="title font-weight-bold">Test "LADDER STAKER" on testnet</span>
          </v-btn>
        </v-flex>
        <!-- <p class="mx-5 mt-10 text-center" max-width="800">
          To thank the WISE Team for creating such an amazing project, I will add the WISE teams referral code to a randomly chosen stake longer than 364 days in every transaction/ladder created with this LadderStaker tool (containing at least 2 stakes)! Thanks WISE Team!
        </p> -->


        <v-card
          class="mx-auto mt-10"
          max-width="700"
          elevation="4"
        >
          <!-- <v-card-title>Title</v-card-title>
          <v-card-subtitle>
            Subtitle
          </v-card-subtitle> -->
          <v-card-text>
            <!-- <v-container fluid> -->
            <v-form v-model="valid_form">
              <v-row class="my-0 py-0">
                <v-col cols="10" sm="3" md="3" lg="3" xl="3" class="my-0 py-0">
                  <p class="ml-1 mb-0 py-sm-4">Total Amount of WISE to Stake</p>
                </v-col>
                <v-col cols="2" sm="1" md="1" lg="1" xl="1">
                  <v-tooltip
                    top
                    content-class="tooltip"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class=""
                        v-on="on"
                      >mdi-help-circle</v-icon>
                    </template>
                    <span v-html="help_total_amount_wise" />
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="my-0 py-0">
                  <v-text-field
                    v-model="amount_wise"
                    @input="calculateAmounts('total')"
                    :rules="[validation_rules.bigger0, validation_rules.floatNumber, validation_rules.sufficientFunds]"
                    outlined
                    suffix="WISE"
                    class="simulatortextfield"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="my-0 py-0 ma-0">
                  <!-- <a class="ml-1 pt-5 mb-0 py-sm-4" @click="amount_wise = balance">Balance: {{ balance }}</a> -->
                  <!-- <p class="ml-1 mb-0 py-sm-4" @click="amount_wise = balance">Balance: {{ balance }}</p> -->
                <v-row v-if="isMetaMaskConnected" >
                  <p class="ml-1 mb-0 py-0 py-sm-1 ma-0">Balance: {{ balance | formatWISE('a', 4, "WISE") }}</p>
                  <v-row>
                    <v-btn x-small @click="setAmountWise(0.01)">
                      1%
                    </v-btn>
                    <v-btn x-small @click="setAmountWise(0.1)">
                      10%
                    </v-btn>
                    <v-btn x-small @click="setAmountWise(0.25)">
                      25%
                    </v-btn>
                    <v-btn x-small @click="setAmountWise(0.5)">
                      50%
                    </v-btn>
                    <v-btn x-small @click="setAmountWise(1)">
                      100%
                    </v-btn>
                  </v-row>
                </v-row>
                  <p v-else class="ma-0 mt-3">Balance:
                    <v-btn
                      color="#f4772e"
                      small
                      class="text-center text-none mx-3 my-0"
                      @click="connectMetamask"
                      >
                      <span class="mr-0">Connect MM</span>
                    </v-btn>
                  </p>
                </v-col>
              </v-row>

              <v-row class="my-0 py-0">
                <v-col cols="10" sm="3" md="3" lg="3" xl="3" class="my-0 py-0">
                  <p class="ml-1 mb-0 py-sm-4">First stake will end in</p>
                </v-col>
                <v-col cols="2" sm="1" md="1" lg="1" xl="1">
                  <v-tooltip
                    top
                    content-class="tooltip"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class=""
                        v-on="on"
                      >mdi-help-circle</v-icon>
                    </template>
                    <span v-html="help_first_ending_interval_number" />
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="my-0 py-0">
                  <v-text-field
                  v-model="first_ending_interval_number"
                  :rules="[validation_rules.bigger0, validation_rules.required, validation_rules.floatNumber]"
                  outlined
                  class="simulatortextfield"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="my-0 py-0">
                  <v-select
                  return-object
                  v-model="selected_first_ending_interval_category"
                  :items="first_ending_interval_category"
                  outlined
                  ></v-select>
                </v-col>
              </v-row>

              <v-row class="my-0 py-0">
                <v-col cols="10" sm="3" md="3" lg="3" xl="3" class="my-0 py-0">
                  <p class="ml-1 mb-0 py-sm-4">Following stakes will end every</p>
                </v-col>
                <v-col cols="2" sm="1" md="1" lg="1" xl="1">
                  <v-tooltip
                    top
                    content-class="tooltip"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class=""
                        v-on="on"
                      >mdi-help-circle</v-icon>
                    </template>
                    <span v-html="help_ending_interval_number" />
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="my-0 py-0">
                  <v-text-field
                    v-model="ending_interval_number"
                    :rules="[validation_rules.bigger0, validation_rules.required, validation_rules.floatNumber]"
                    outlined
                    class="simulatortextfield"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="my-0 py-0">
                  <v-select
                    v-model="selected_ending_interval_category"
                    :items="ending_interval_category"
                    return-object
                    outlined
                  ></v-select>
                </v-col>
              </v-row>

              <v-row class="my-0 py-0">
                <v-col cols="10" sm="3" md="3" lg="3" xl="3" class="my-0 py-0">
                  <p class="ml-1 mb-0 py-sm-4">Number of Stakes</p>
                </v-col>
                <v-col cols="2" sm="1" md="1" lg="1" xl="1">
                  <v-tooltip
                    top
                    content-class="tooltip"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class=""
                        v-on="on"
                      >mdi-help-circle</v-icon>
                    </template>
                    <span v-html="help_number_stakes" />
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="my-0 py-0">
                  <v-text-field
                    v-model="number_stakes"
                    type="number"
                    :rules="[validation_rules.bigger0, validation_rules.smaller36, validation_rules.required, validation_rules.integerNumber]"
                    outlined
                    class="simulatortextfield"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="my-0 py-0">
                <v-col cols="10" sm="3" md="3" lg="3" xl="3" class="my-0 py-0">
                  <p class="ml-1 mb-0 py-sm-4">Amount per Stake</p>
                </v-col>
                <v-col cols="2" sm="1" md="1" lg="1" xl="1">
                  <v-tooltip
                    top
                    content-class="tooltip"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class=""
                        v-on="on"
                      >mdi-help-circle</v-icon>
                    </template>
                    <span v-html="help_amount_per_stake" />
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="my-0 py-0">
                  <v-text-field
                    v-model="amount_per_stake"
                    @input="calculateAmounts('perShare')"
                    :rules="[validation_rules.bigger0, validation_rules.required, validation_rules.floatNumber]"
                    outlined
                    suffix="WISE"
                    class="simulatortextfield"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- <v-row class="my-0 py-0">
                <v-col cols="10" sm="3" md="3" lg="3" xl="3" class="my-0 py-0">
                  <p class="ml-1 mb-0 py-sm-4">Referral Address</p>
                </v-col>
                <v-col cols="2" sm="1" md="1" lg="1" xl="1">
                  <v-tooltip
                    top
                    content-class="tooltip"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class=""
                        v-on="on"
                      >mdi-help-circle</v-icon>
                    </template>
                    <span v-html="help_referral_address" />
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="my-0 py-0">
                  <v-text-field
                    v-model="referral_address"
                    @input="calculateAmounts('perShare')"
                    :rules="[validation_rules.validAccount]"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row> -->

              <v-row>
                <v-col cols="12" sm="1" md="1" lg="1" xl="1">
                  <v-checkbox
                  class="my-3 ml-3 ml-sm-0 ml-md-0 ml-lg-0 ml-xl-0 py-0"
                  v-model="referral_used"
                  disabled
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="11" md="11" lg="11" xl="11">
                  I agree that I will use the referral code of wiseinfo.io and the WISE Team and will hereby get +10% more shares for free.
                </v-col>
              </v-row>



          <!-- </v-container> -->
            </v-form>

          </v-card-text>
        </v-card>

        <v-container
          class="mt-10 pa-1"
        >

          <v-radio-group
            v-model="stakeCreationModus"
            mandatory
            class="mb-5 ml-2"
            >
            <v-radio
            label="Create all stakes in one transaction"
            value="all"
            ></v-radio>
            <v-radio
            label="Create every stake individually"
            value="individual"
            ></v-radio>
          </v-radio-group>

          <h3 class="mb-3">Following stakes will be generated:</h3>

          <v-card class="mt-4" elevation="4">
            <v-card-text>

          <v-simple-table
            dense
            fixed-header
            class="mx-0">
              <thead>
                <tr>
                  <th>Stake #</th>
                  <th class="text-right">Length</th>
                  <th class="text-right">End Date</th>
                  <th class="text-right">Amount</th>
                  <th class="text-right">Bonus</th>
                  <th v-if="stakeCreationModus=='individual'" class="text-right">Generate (MetaMask)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="stake in stakes" :key="stake.index" class="ml-5 pr-0">
                  <td>{{ stake.index + 1 }}</td>
                  <td class="text-right">{{ stake.length }} days<br /><span class="stakelength_hr">{{ stake.length_hr }}</span></td>
                  <td class="text-right">{{ stake.enddate }}</td>
                  <td class="text-right">{{ stake.amount }} WISE</td>
                  <td class="text-right">{{ stake.bonus }}</td>
                  <td v-if="stakeCreationModus=='individual'" class="text-right">
                    <v-btn
                      v-if="!valid_form === true"
                      color="#29abb5"
                      class="mx-0 my-2 text-none"
                      disabled
                      >
                      <div >
                        Invalid Inputs
                      </div>
                    </v-btn>
                    <v-btn
                      v-else-if="buttonStates[stake.index]===0"
                      color="#29abb5"
                      class="mx-0 my-2 text-none"
                      @click="createStake(stake)"
                      >
                      <div >
                        Create Stake
                      </div>
                    </v-btn>
                    <v-btn
                      v-else-if="buttonStates[stake.index]===1"
                      color="#29abb5"
                      class="mx-0 my-2 text-none"
                      disabled
                      >
                      <div>
                        <v-progress-circular
                        indeterminate
                        size="20"
                        width="2"
                        color="white"
                        class="my-5"
                        ></v-progress-circular>
                        Awaiting confirmation in MetaMask
                      </div>
                    </v-btn>
                    <v-btn
                    v-else-if="buttonStates[stake.index]===2"
                    color="#29abb5"
                    class="mx-0 my-2 text-none"
                    @click="createStake(stake)"
                    >
                    <div >
                      Aborted. Create Stake (Retry)
                    </div>
                  </v-btn>
                    <v-btn
                    v-else-if="buttonStates[stake.index]===3"
                    color="#29abb5"
                    class="mx-0 my-2 text-none"
                    >
                    <div >
                      Transaction Submitted<br />
                      Waiting for Confirmation...
                    </div>
                  </v-btn>
                    <v-btn
                    v-else-if="buttonStates[stake.index]===4"
                    color="#68AA13"
                    class="mx-0 my-2 text-none"
                    >
                    <div >
                      Transaction Confirmed
                    </div>
                  </v-btn>
                  </td>
                </tr>
              </tbody>
          </v-simple-table>

          </v-card-text>
        </v-card>

        </v-container>

        <v-flex v-if="stakeCreationModus=='all'" class="d-flex flex-column justify-center mt-3">

          <div class="d-flex flex-column text-center justify-center mt-3">
            <div class="d-flex flex-wrap text-center justify-center mt-3">
            <v-btn
              v-if="!valid_form === true"
              color="#29abb5"
              x-large
              contain
              class="mx-0 my-2 text-none"
              disabled
              >
              <div>
                Invalid Inputs
              </div>
            </v-btn>

            <div v-else>
            <v-btn
              v-if="creatingAllStakes===0"
              color="#29abb5"
              x-large
              contain
              class="mx-0 my-2 text-none"
              @click="createAllStakes()"
            >
              <div>
                Create All Stakes
              </div>

            </v-btn>
            <v-btn
              v-if="creatingAllStakes===1"
              color="#29abb5"
              x-large
              contain
              class="mx-0 my-2 text-none"
              disabled
            >
              <div>
                <v-progress-circular
                indeterminate
                size="20"
                width="2"
                color="white"
                class="my-5"
                ></v-progress-circular>
                Awaiting confirmation in MetaMask
              </div>
            </v-btn>
            <v-btn
              v-if="creatingAllStakes===2"
              color="#29abb5"
              x-large
              contain
              class="mx-0 my-2 text-none"
              @click="createAllStakes()"
            >
              <div >
                Aborted. Create All Stakes (Retry)
              </div>
            </v-btn>
            <v-btn
              v-if="creatingAllStakes===3"
              color="#29abb5"
              x-large
              height="70"
              contain
              class="mx-0 my-2 text-none"
            >
              <div >
                Transaction Submitted<br />
                Waiting for Confirmation...<br />
              </div>
            </v-btn>
            <v-btn
              v-if="creatingAllStakes===4"
              color="#68AA13"
              x-large
              contain
              class="mx-0 my-2 text-none"
            >
              <div >
                Transaction Confirmed<br  />
                All Stakes Created<br />
              </div>
            </v-btn>
            <v-btn
              v-if="creatingAllStakes === 4"
              color="#29abb5"
              x-large
              contain
              class="ml-2 my-2 text-none"
              @click="resetButtons()"
            >
              <div>
                Reset
              </div>
            </v-btn>
            </div>
          </div>
            <div>
              <a v-if="showTxLink" :href="txlink" target="_blank" class="caption etherscanlink">View transaction
                <v-icon
                  dark
                  medium
                >
                  mdi-link
                </v-icon>
              </a>
            </div>
        </div>
        </v-flex>

      </v-flex>

    </v-flex>
  </div>
</template>

<script>
import config from "@/utils/config.json";

  import {
    mapState
  } from 'vuex';

  import {
    connectWeb3,
  } from '../utils/getWeb3';

  import Vue from 'vue';

  import {
    // getStakes,
    getBalance,
    // isValidAccount
  } from "../utils/dataPoller";

  //   import {
  //     getWeb3,
  //     getWiseContract,
  // } from "../utils/contract_mainnet_staking";

  var VueScrollTo = require('vue-scrollto');

  export default {
    name: "LadderStaker",
    data() {
      return {
        wiseContract: null,
        web3: null,
        amount_wise: 13000,
        balance: -1,
        number_stakes: 10,
        referral_used: true,
        valid_form: true,
        // referral_address: this.getReferralAccount(),
        validation_rules: {
          required: value => !!value || 'Required',
          bigger0: value => parseFloat(value) > 0 || 'Number Bigger 0',
          smaller36: value => parseFloat(value) < 36 || 'Number Smaller 36',
          integerNumber: value => /^\d+$/.test(value) || 'Natural Number',
          floatNumber: value => /^\d+(\.\d+)?$/.test(value) || 'Floating Point Number',
          // validAccount: value => isValidAccount(value) || 'Invalid Account',
          sufficientFunds: value => !isNaN(parseFloat(value)) && (!this.isMetaMaskConnected || (this.isMetaMaskConnected && value <= this.balance)) || 'Insufficient Funds',
        },
        stakeCreationModus: "all",
        txAborted: 0,
        txSubmitted: 0,
        txConfirmed: 0,
        txlink: "",
        first_ending_interval_number: 1,
        first_ending_interval_category: [{
            text: "Days",
            value: 1
          },
          {
            text: "Weeks",
            value: 7
          },
          {
            text: "Months",
            value: 30
          },
          {
            text: "Years",
            value: 365
          },
        ],
        selected_first_ending_interval_category: {
          text: "Years",
          value: 365
        },
        ending_interval_number: 1,
        ending_interval_category: [{
            text: "Days",
            value: 1
          },
          {
            text: "Weeks",
            value: 7
          },
          {
            text: "Months",
            value: 30
          },
          {
            text: "Years",
            value: 365
          },
        ],
        selected_ending_interval_category: {
          text: "Months",
          value: 30
        },
        amount_per_stake: 0,
        last_edit: "total",
        stakes: [],
        buttonStates: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        creatingAllStakes: 0,
        help_total_amount_wise: "How much WISE I want to put into the ladder stakes in total.",
        help_number_stakes: "How many stakes you want to create in total. Max is 35 because of block size",
        help_first_ending_interval_number: "When should the first stake end. Example: Set it to 1 year, if you want your monthly ladder to start after the first year",
        help_ending_interval_number: "Define the interval between the ends of your ladder stakes.",
        // help_referral_address: "Use this address as a Referral for stakes shorter than 365 days. Stakes for 365 days or longer will automatically contain the referrals of wiseinfo.io and the official WISE team.",
        help_amount_per_stake: "Set how much Wise you want per stake.",
      }
    },
    mounted() {
      this.calculateAmountPerStake();
      this.update_ladder_stakes();
      this.$nextTick(() => {
        if (this.$route.hash === "#LadderStaker") {
          this.scrollMeTo("LadderStaker");
        }
      });
    },
    computed: {
      showTxLink() {
        return this.creatingAllStakes === 3 || this.creatingAllStakes === 4;
      },
      account() {
        return this.$store.state.web3.account;
      },

      isMetaMaskConnected() {
        return this.$store.state.web3.connected;
      },

      referralLink() {
        return "https://wisetoken.net/?w=" + config.referralAccount;
      },
      ...mapState({
        currentETHPrice: state => state.currentETHPrice,
        account: state => state.web3.account,
      }),
    },
    watch: {
      currentETHPrice() {
        this.price_usd;
        this.my_earnings_usd;
      },
      amount_wise() {
        this.update_ladder_stakes();
      },
      number_stakes() {
        this.calculateAmounts();
        this.update_ladder_stakes();
      },
      ending_interval_number() {
        this.update_ladder_stakes();
      },
      selected_ending_interval_category() {
        this.update_ladder_stakes();
      },
      first_ending_interval_number() {
        this.update_ladder_stakes();
      },
      selected_first_ending_interval_category() {
        this.update_ladder_stakes();
      },
      amount_per_stake() {
        this.update_ladder_stakes();
      },
      async account() {
        this.balance = await getBalance(this.$store.state.web3.account);
        this.amount_wise = this.balance;
        this.calculateAmounts();
      }
    },
    methods: {
      // getReferralAccount() {
      //   return config.referralAccount;
      // },
      scrollMeTo(anchor) {
        VueScrollTo.scrollTo(document.getElementById(anchor));
      },
      analyticsCountSuccessfulLadderStaker() {
        this.$ga.event('LadderStaker_Success', 'Successful LadderStaker', '');
      },
      analyticsCountFailedLadderStaker() {
        this.$ga.event('LadderStaker_Fail', 'Failed LadderStaker', '');
      },
      setAmountWise(percentage) {
        this.amount_wise = (percentage * this.balance);
        this.calculateAmounts('total');
      },
      async connectMetamask() {
        await connectWeb3();
        this.balance = await getBalance(this.$store.state.web3.account);
      },
      calculateAmountPerStake() {
        this.amount_per_stake = parseFloat((this.amount_wise / this.number_stakes).toFixed(8).slice(0, -2));
      },
      calculateAmountWise() {
        this.amount_wise = this.amount_per_stake * this.number_stakes;
      },
      calculateAmounts(lastEdit = "") {
        if (lastEdit !== "") {
          this.last_edit = lastEdit;
        }
        if (this.last_edit == "total") {
          this.calculateAmountPerStake();
        } else if (this.last_edit == "perShare") {
          this.calculateAmountWise();
        }
      },
      // async createContract() {
      //   if (this.wiseContract === null) {
      //     this.wiseContract = await getWiseContract();
      //     this.web3 = await getWeb3();
      //   }
      // },

      async createContract() {
        let {
          getWiseContract,
          getWeb3
        } = process.env.VUE_APP_ENVIRONMENT === "development" ?
          await import('../utils/contract_testnet_staking') :
          await import('../utils/contract_mainnet_staking')
        if (this.wiseContract === null) {
          this.wiseContract = await getWiseContract();
        }
        if (this.web3 === null) {
          this.web3 = await getWeb3();
        }
      },


      async createStake(stake) {

        await this.createContract();

        this.txlink = "";
        let stakedAmount = this.web3.utils.toWei(stake.amount.toString(), 'ether');
        let lockDays = stake.length;
        let referrerAddress = config.referralAccount;

        let contractData = this.wiseContract.methods.createStake(stakedAmount, lockDays, referrerAddress).encodeABI();

        const transactionParameters = {
          // nonce: '0x00', // ignored by MetaMask
          // gasPrice: '0x09184e72a000', // customizable by user during MetaMask confirmation.
          // gas: '0x2710', // customizable by user during MetaMask confirmation.
          to: this.wiseContract._address, // Required except during contract publications.
          from: window.ethereum.selectedAddress, // must match user's active address.
          // value: '0x00', // Only required to send ether to the recipient from the initiating external account.
          data: contractData, // Optional, but used for defining smart contract creation and interaction.
          // chainId: 1, // Used to prevent transaction reuse across blockchains. Auto-filled by MetaMask.
        };

        try {
          Vue.set(this.buttonStates, stake.index, 1);
          const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
          });
          let domain = process.env.VUE_APP_ENVIRONMENT === "development" ? "ropsten.etherscan.io" : "etherscan.io";
          this.txlink = `https://${domain}/tx/${txHash}`;
          Vue.set(this.buttonStates, stake.index, 3);
          this.getTransactionReceipt(txHash, stake);
          this.checkTransactionStatus();
        } catch (e) {
          Vue.set(this.buttonStates, stake.index, 2);
          this.checkTransactionStatus();
          this.analyticsCountFailedLadderStaker();
        }

      },
      async getTransactionReceipt(txHash, stake) {
        let receipt = null;
        while (receipt === null) {
          // we are going to check every second if transation is mined or not, once it is mined we'll leave the loop
          receipt = await this.getTransactionReceiptPromise(txHash);
          await this.sleep(1000);
        }
        if (stake !== "all") {
          await Vue.set(this.buttonStates, stake.index, 4);
          this.analyticsCountSuccessfulLadderStaker();
        } else {
          let domain = process.env.VUE_APP_ENVIRONMENT === "development" ? "ropsten.etherscan.io" : "etherscan.io";
          this.txlink = `https://${domain}/tx/${txHash}`;
          this.creatingAllStakes = 4;
          this.analyticsCountSuccessfulLadderStaker();
        }
        return receipt;
      },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      async getTransactionReceiptPromise(txHash) {
        return new Promise(((resolve, reject) => {
          this.web3.eth.getTransactionReceipt(txHash, function(err, data) {
            if (err !== null) reject(err);
            else resolve(data);
          });
        }));
      },
      //
      // async createAllStakes() {
      //   this.creatingAllStakes = 1;
      //   for (let stake of this.stakes) {
      //     console.log(stake);
      //     await this.createStake(stake);
      //     this.checkTransactionStatus();
      //     await this.sleep(500);
      //   }
      //   this.checkTransactionStatus();
      // },

      async createAllStakes() {
        await this.createContract();

        let stakedAmounts = [];
        let lockDays = [];
        let referrerAddresses = [];

        // let startIndexLongStakes = -1;
        // let endIndexLongStakes = -1
        // let randomIndex = -1;

        for (let stake of this.stakes) {
          // if (startIndexLongStakes === -1 && this.stakes.length > 1 && stake.length >= 365) {
          //   startIndexLongStakes = stake.index;
          // }
          stakedAmounts.push(this.web3.utils.toWei(stake.amount.toString(), 'ether'));
          lockDays.push(stake.length);
          referrerAddresses.push(config.referralAccount);
        }
        // if (startIndexLongStakes >= 0) {
        //   endIndexLongStakes = this.stakes.length - 1;
        // }

        // randomIndex = Math.floor(Math.random() * (endIndexLongStakes - startIndexLongStakes + 1)) + startIndexLongStakes;
        // if (randomIndex >= 0 && randomIndex <= this.stakes.length) {
        //   referrerAddresses[randomIndex] = config.teamReferralAccount;
        // }

        // console.log(`startIndexLongStakes: ${startIndexLongStakes}, endIndexLongStakes: ${endIndexLongStakes}, randomIndex: ${randomIndex}`);
        // console.log(referrerAddresses);

        let contractData = this.wiseContract.methods.createStakeBulk(stakedAmounts, lockDays, referrerAddresses).encodeABI();

        const transactionParameters = {
          to: this.wiseContract._address, // Required except during contract publications.
          from: window.ethereum.selectedAddress, // must match user's active address.
          data: contractData, // Optional, but used for defining smart contract creation and interaction.
        };

        try {
          this.creatingAllStakes = 1;
          const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
          });
          let domain = process.env.VUE_APP_ENVIRONMENT === "development" ? "ropsten.etherscan.io" : "etherscan.io";
          this.txlink = `https://${domain}/tx/${txHash}`;
          this.creatingAllStakes = 3;
          this.getTransactionReceipt(txHash, "all");
        } catch (e) {
          this.creatingAllStakes = 2;
          this.analyticsCountFailedLadderStaker();
        }
      },


      checkTransactionStatus() {
        this.txAborted = this.buttonStates.filter(state => state == 2).length;
        this.txSubmitted = this.buttonStates.filter(state => state == 3).length;
        this.txConfirmed = this.buttonStates.filter(state => state == 4).length;

        console.log(`this.txConfirmed: ${this.txConfirmed}, this.number_stakes: ${this.number_stakes}`);

        if (this.txConfirmed == this.number_stakes) {
          this.creatingAllStakes = 4;
        } else if (this.txAborted > 0 || this.txSubmitted > 0 || this.txConfirmed > 0) {
          this.creatingAllStakes = 2;
        }
      },
      getStake(index) {
        return this.stakes.find(stake => stake.index === index);
      },
      get_humanreadable_length(days) {
        let days_hr = "";
        let years = Math.floor(days / 365);
        if (years > 0) {
          days_hr += years + "Y" + (years > 1 ? "" : "");
          days -= years * 365;
        }
        let months = Math.floor(days / 30);
        if (months > 0) {
          days_hr += " " + months + "M" + (months > 1 ? "" : "");
          days -= months * 30;
        }
        let weeks = Math.floor(days / 7);
        if (weeks > 0) {
          days_hr += " " + weeks + "W" + (weeks > 1 ? "" : "");
          days -= weeks * 7;
        }
        if (days > 0) {
          days_hr += " " + days + "D" + (days > 1 ? "" : "");
        }

        return days_hr;
      },
      getBonus(days) {
        let bonus = 0;
        let bonusPerDayShortStake = 0.25 / (5 * 365);
        let bonusPerDayLongStake = 0.05 / ((42 - 5) * 365);
        let referralBonus = 0.1;
        if (days <= 5 * 365) {
          bonus = days * bonusPerDayShortStake;
        } else {
          bonus = 0.25 + (days - 5 * 365) * bonusPerDayLongStake;
        }
        bonus += referralBonus;
        return bonus;
      },
      resetButtons() {
        this.resetCreateStakeButtonStates();
        this.resetCreateAllButtonState();
      },
      resetCreateStakeButtonStates() {
        this.buttonStates = [];
        for (let i = 0; i < this.number_stakes; i++) {
          this.buttonStates.push(0);
        }
      },
      resetCreateAllButtonState() {
        this.txAborted = 0;
        this.txSubmitted = 0;
        this.txConfirmed = 0;
        this.creatingAllStakes = 0;
        this.txlink = "";
      },
      update_ladder_stakes() {
        this.stakes = [];
        for (let i = 0; i < this.number_stakes; i++) {
          let length = Math.round((i) * this.ending_interval_number * this.selected_ending_interval_category.value + this.first_ending_interval_number * this.selected_first_ending_interval_category.value);
          let enddate = new Date();
          enddate.setDate(enddate.getUTCDate() + length + 1);

          let bonus = this.getBonus(length);
          let bonusString = (bonus * 100).toFixed(2) + "%";
          this.stakes.push({
            index: i,
            length: length,
            length_hr: this.get_humanreadable_length(length),
            enddate: enddate.toLocaleDateString() + " UTC",
            amount: this.amount_per_stake,
            bonus: bonusString
          })
        }
        this.resetButtons();
      },
      captureReferralLink(category, url) {
        this.$ga.event(category, 'click', url, 1234);
      }
    }
  };
</script>

<style lang="css" scoped>
  .container {
    max-width: 900px;
  }
  .stakelength_hr {
    font-size: 0.75em;
    color: #888888;
  }
  .simulatortextfield {
    width: 180px;
  }
  .simulatortextfield input {
    text-align: center;
  }
  a {
    color: white !important;
  }
  a.etherscanlink {
    text-decoration: none !important;
  }
</style>
